const LEGACY_DATA_KEY_HTML_REG_EXP =
  /<data-key\s+id="([^"]+)"(?:\s+source-doc-id="([^"]+)")?\s*>[\s\S]*?<\/data-key>/g;

const LEGACY_DATA_KEY_REG_EXP = /@dk\[([^\]]+)\]\{doc:"([^"]+)"\}/g;

const toCanonicalDataKeyReference = (dataKeyId: string): string =>
  `{{ ${dataKeyId} }}`;

export const replaceLegacyDataKeyMarkup = (
  markdown: string,
  replaceReference: (dataKeyId: string, sourceDocId?: string) => string
): string => {
  const normalizedLegacyHtml = markdown.replace(
    LEGACY_DATA_KEY_HTML_REG_EXP,
    (_match: string, dataKeyId: string, sourceDocId?: string) => {
      return replaceReference(dataKeyId, sourceDocId);
    }
  );

  return normalizedLegacyHtml.replace(
    LEGACY_DATA_KEY_REG_EXP,
    (_match: string, dataKeyId: string, sourceDocId: string) => {
      return replaceReference(dataKeyId, sourceDocId);
    }
  );
};

export const normalizeLegacyDataKeyMarkup = (markdown: string): string =>
  replaceLegacyDataKeyMarkup(markdown, (dataKeyId) =>
    toCanonicalDataKeyReference(dataKeyId)
  );
